import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Tab() {
    const { useLang, useState, useRouter, useEffect, gtm } = useGlobal();
    const { t } = useLang('RV');
    const { locale } = useRouter();
    const [active, setActive] = useState('#RV-B');
    const [top, setTop] = useState(0);
    const EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es'];

    const tabs_map: any = {
        eu: ['#RV-B', '#RV-C', '#RV-D', '#RV-F', '#RV-G', '#RV-H', '#RV-J'],
        kr: ['#RV-B', '#RV-C', '#RV-D', '#RV-F', '#RV-H', '#RV-J'],
        us: ['#RV-B', '#RV-C', '#RV-D', '#RV-F', '#RV-H', '#RV-J', '#RV-K'],
        ca: ['#RV-B', '#RV-C', '#RV-D', '#RV-F', '#RV-H', '#RV-J', '#RV-K'],
        au: ['#RV-B', '#RV-C', '#RV-D', '#RV-F', '#RV-H', '#RV-J', '#RV-K'],
        uk: ['#RV-B', '#RV-C', '#RV-D', '#RV-F', '#RV-G', '#RV-H', '#RV-J', '#RV-K'],
        de: ['#RV-B', '#RV-C', '#RV-D', '#RV-F', '#RV-G', '#RV-H', '#RV-J', '#RV-K'],
        fr: ['#RV-B', '#RV-C', '#RV-D', '#RV-F', '#RV-G', '#RV-H', '#RV-J', '#RV-K'],
        it: ['#RV-B', '#RV-C', '#RV-D', '#RV-F', '#RV-G', '#RV-H', '#RV-J', '#RV-K'],
        es: ['#RV-B', '#RV-C', '#RV-D', '#RV-F', '#RV-G', '#RV-H', '#RV-J', '#RV-K'],
    };

    const tabs = tabs_map[locale] || tabs_map.us;

    const handleChangTab = (tab: string, k: number) => {
        setActive(tab);
        const tabs = document.querySelector('.RV-Tab .tabs') as HTMLElement;
        if (tabs && tabs?.offsetWidth > window.innerWidth) {
            const tabBox = document.querySelector('.RV-Tab .tabs-box') as HTMLElement;
            const target = document.querySelector(`.RV-Tab .tabs-box .tab-${tab}`) as HTMLElement;
            tabBox &&
                target &&
                tabBox.scrollTo({
                    left: target.offsetLeft - 24,
                    behavior: 'smooth',
                });
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: 'none',
            button_name: t(`Tab_${k + 1}`),
        });
    };

    useEffect(() => {
        setTimeout(() => {
            let h = 0;
            const elems = ['.announcement-bar', '.activity-bar'];
            elems?.map((cls) => {
                const elem = document.querySelector(cls);
                if (elem) {
                    const computedStyle = window.getComputedStyle(elem);
                    const positionValue = computedStyle.getPropertyValue('position');
                    if (positionValue === 'sticky') {
                        h += elem.offsetHeight;
                    }
                }
            });
            setTop(h);
            tabs?.map((tab: string) => {
                AniContainer.create({
                    triggerElement: tab.replace('#', '.'),
                    triggerHook: 1,
                    offset: 100,
                    duration: '200%',
                    onEnter: () => setActive(tab),
                });
            });
        }, 2000);
    }, []);

    return (
        <div id="RV-Tab" className={`RV-Tab ${css['RV-Tab']}`} style={{ top: `${top}px` }}>
            <div className="tabs-box">
                <ul className="tabs">
                    {tabs?.map((tab: string, k: number) => (
                        <li className={`tab tab-${tab} ${active === tab ? 'active' : ''}`} key={k} onClick={() => handleChangTab(tab, k)}>
                            <a href={tab} className="tab-link">
                                {t(`Tab_${k + (k >= 4 && !EU_SITES.includes(locale) ? 2 : 1)}`)}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
